<template>
    <div class="eventManage_jsjb">
        <div ref="searchHight" class="jsjb_form">
            <el-form
                :model="formSearch"
                ref="ruleFormRef"
                label-width="auto"
            >
                <div class="jsjb_form_top">
                    <div class="jsjb_form_top_left">
                        <p class="jsjb_form_label">工单检索</p>
                        <div class="jsjb_form_left">
                            <!--<el-form-item prop="radio1">-->
                            <!--<el-radio-group size="large" v-model="">-->
                            <!--<el-radio-button label="1">区</el-radio-button>-->
                            <!--<el-radio-button label="2">中心</el-radio-button>-->
                            <!--</el-radio-group>-->
                            <!--</el-form-item>-->
                            <el-form-item prop="gdJzsjStartTogdJzsjEnd">
                                <el-date-picker
                                    v-model="formSearch.gdJzsjStartTogdJzsjEnd"
                                    value-format="YYYY-MM-DD HH:mm:ss"
                                    @change="timeRangeChange"
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="开始时间"
                                    end-placeholder="截止时间"

                                />
                            </el-form-item>
                            <el-form-item prop="selectTime">
                                <el-radio-group :disabled="timeRangeDisabled" @change="selectTimeChange"
                                                v-model="formSearch.selectTime" class="jsjb_form_selectTime"
                                                size="large">
                                    <el-radio-button label="1">今</el-radio-button>
                                    <el-radio-button label="2">3</el-radio-button>
                                    <el-radio-button label="3">7</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item prop="queryJjcs">
                                <el-checkbox v-model="formSearch.queryJjcs">即将超时</el-checkbox>
                            </el-form-item>
                            <el-form-item prop="queryYjcs">
                                <el-checkbox v-model="formSearch.queryYjcs">已经超时</el-checkbox>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="jsjb_form_top_right">
                        <el-form-item prop="search">
                            <el-input v-model="formSearch.search" @keydown="inputKeydown(event)" class="jsjb_form_input"
                                      placeholder="请输入编号、地点、标题、内容">
                                <template #prefix>
                                    <el-icon class="el-input__icon">
                                        <search/>
                                    </el-icon>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button class="jsjb_form_reset" @click="resetForm(ruleFormRef)">重置</el-button>
                        </el-form-item>
                        <div class="jsjb_form_bottom_btn" style="margin-left:10px;">
                            <el-button class="" type="primary" @click="submitForm">
                                <el-icon>
                                    <Search/>
                                </el-icon>
                                查询
                            </el-button>
                        </div>
                        <div v-if="true" class="jsjb_form_highSearch" @click="highSearch">
                            <el-icon>
                                <search/>
                            </el-icon>
                            <span>高级查询</span>
                            <el-icon v-if="highSearchArrow">
                                <caret-bottom/>
                            </el-icon>
                            <el-icon v-else>
                                <caret-top/>
                            </el-icon>
                        </div>
                    </div>
                </div>
                <div class="jsjb_form_bottom" v-if="!highSearchArrow">
                    <div class="jsjb_form_bottom_list">
                        <div class="jsjb_form_bottom_item"  v-if="false">
                            <div class="jsjb_form_bl_label">
                                工单类型
                            </div>
                            <el-form-item prop="gdGdlx_dic">
                                <el-cascader
                                    v-model="formSearch.gdGdlx_dic"
                                    :options="highSearchSelectedArray.cdg_wgsj_gdlx"
                                    filterable
                                />
                            </el-form-item>
                        </div>
                        <div class="jsjb_form_bottom_item">
                            <div class="jsjb_form_bl_label">
                                事件类型
                            </div>
                            <el-form-item prop="gdSjlx_dic">
                                <el-cascader
                                    v-model="formSearch.gdSjlx_dic"
                                    :options="highSearchSelectedArray.cdg_wgsjlx"
                                    filterable
                                />
                            </el-form-item>
                        </div>
                        <div class="jsjb_form_bottom_item">
                            <div class="jsjb_form_bl_label">
                                承办单位
                            </div>
                            <el-form-item prop="czFpdxid_dic">
                                <el-cascader
                                    v-model="formSearch.czFpdxid_dic"
                                    :options="highSearchSelectedCbdw"
                                    filterable
                                />
                            </el-form-item>
                        </div>
                    </div>
                    <div class="jsjb_form_bottom_list">
                        <div class="jsjb_form_bottom_item">
                            <div class="jsjb_form_bl_label">
                                工单状态
                            </div>
                            <el-form-item prop="formKey_dic">
                                <el-cascader
                                    v-model="formSearch.formKey_dic"
                                    :options="highSearchSelectedArray.cdg_wgsj_gdzt"
                                    filterable
                                />
                            </el-form-item>
                        </div>
                        <div class="jsjb_form_bottom_item" v-if="false">
                            <div class="jsjb_form_bl_label">
                                工单标识
                            </div>
                            <el-form-item prop="gdGdbs_dic">
                                <el-cascader
                                    filterable
                                    v-model="formSearch.gdGdbs_dic"
                                    :options="highSearchSelectedArray.cdg_wgsj_gdbs"
                                />
                            </el-form-item>
                        </div>
                        <div class="jsjb_form_bottom_item">
                            <div class="jsjb_form_bl_label">
                                案发村社
                            </div>
                            <el-form-item prop="gdAfcs_dic">
                                <el-cascader
                                    filterable
                                    v-model="formSearch.gdAfcs_dic"
                                    :options="highSearchSelectedArray.cdg_wgsj_afcs"
                                />
                            </el-form-item>
                        </div>
                    </div>
                    <!--<div class="jsjb_form_bottom_list">-->
                    <!--<div class="jsjb_form_bl_label">-->
                    <!--过滤匹配条件-->
                    <!--</div>-->
                    <!--<el-form-item prop="query_glpptj">-->
                    <!--<el-select-->
                    <!--v-model="formSearch.query_glpptj"-->
                    <!--class="jsjb_form_bl_first"-->
                    <!--placeholder="请选择"-->
                    <!--&gt;-->
                    <!--<el-option-->
                    <!--v-for="item in filterMatchConditionSelect"-->
                    <!--:key="item.value"-->
                    <!--:label="item.label"-->
                    <!--:value="item.value"-->
                    <!--/>-->
                    <!--</el-select>-->
                    <!--</el-form-item>-->
                    <!--</div>-->
                    <!--<div class="jsjb_form_bottom_list">-->
                    <!--<div class="jsjb_form_bl_label">-->
                    <!--关键词-->
                    <!--</div>-->
                    <!--<el-form-item :prop="['queryParam',0,'field']">-->
                    <!--<el-select-->
                    <!--class="jsjb_form_bl_first"-->
                    <!--v-model="formSearch.queryParam[0].field"-->
                    <!--@change="selectKeyowordChange(0)"-->
                    <!--placeholder="请选择"-->
                    <!--&gt;-->
                    <!--<el-option-->
                    <!--v-for="item in advancedQueryKeyword"-->
                    <!--:key="item.field"-->
                    <!--:label="item.name"-->
                    <!--:value="item.field"-->
                    <!--/>-->
                    <!--</el-select>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item :prop="['queryParam',0,'gzcs']">-->
                    <!--<el-select-->
                    <!--class="jsjb_form_bl_second"-->
                    <!--v-model="formSearch.queryParam[0].gzcs"-->
                    <!--placeholder="请选择"-->
                    <!--&gt;-->
                    <!--<el-option-->
                    <!--v-for="item in formSearch.queryParam[0].selectList3"-->
                    <!--:key="item.value"-->
                    <!--:label="item.label"-->
                    <!--:value="item.value"-->
                    <!--/>-->
                    <!--</el-select>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item v-if="formSearch.queryParam[0].inputType=='select'" :prop="['queryParam',0,'cxcs']">-->
                    <!--<el-cascader  class="jsjb_form_bl_input"-->
                    <!--:props="{ emitPath: false }" clearable placeholder="请选择"-->
                    <!--v-model="formSearch.queryParam[0].cxcs"-->
                    <!--:options="formSearch.queryParam[0].selectList4"/>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item v-else-if="formSearch.queryParam[0].inputType=='date'" :prop="['queryParam',0,'cxcs']">-->
                    <!--<el-date-picker-->
                    <!--v-model="formSearch.queryParam[0].cxcs"-->
                    <!--class="jsjb_form_bl_input"-->
                    <!--format="YYYY-MM-DD HH:mm:ss"-->
                    <!--value-format="YYYY-MM-DD HH:mm:ss"-->
                    <!--type="datetime"-->
                    <!--placeholder="选择日期时间"-->
                    <!--/>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item v-else :prop="['queryParam',0,'cxcs']">-->
                    <!--<el-input  v-model="formSearch.queryParam[0].cxcs" class="jsjb_form_bl_input"-->
                    <!--placeholder="请输入"/>-->
                    <!--</el-form-item>-->
                    <!--&lt;!&ndash;<el-input v-model="formSearch.queryParam[0].cxcs" class="jsjb_form_bl_input" placeholder="请输入"/>&ndash;&gt;-->
                    <!--<el-button @click="addKeyword">-->
                    <!--<el-icon>-->
                    <!--<plus/>-->
                    <!--</el-icon>-->
                    <!--</el-button>-->
                    <!--</div>-->
                    <!--<div class="jsjb_form_bottom_list" v-for="(item,index) in formSearch.queryParam.slice(1)">-->
                    <!--<div class="jsjb_form_bl_label">-->
                    <!--关键词-->
                    <!--</div>-->
                    <!--<el-form-item :prop="['queryParam',index+1,'field']">-->
                    <!--<el-select-->
                    <!--class="jsjb_form_bl_first"-->
                    <!--v-model="formSearch.queryParam[index+1].field"-->
                    <!--@change="selectKeyowordChange(index+1)"-->
                    <!--placeholder="请选择"-->
                    <!--&gt;-->
                    <!--<el-option-->
                    <!--v-for="item in advancedQueryKeyword"-->
                    <!--:key="item.field"-->
                    <!--:label="item.name"-->
                    <!--:value="item.field"-->
                    <!--/>-->
                    <!--</el-select>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item :prop="['queryParam',index+1,'gzcs']">-->
                    <!--<el-select-->
                    <!--class="jsjb_form_bl_second"-->
                    <!--v-model="formSearch.queryParam[index+1].gzcs"-->
                    <!--placeholder="请选择"-->
                    <!--&gt;-->
                    <!--<el-option-->
                    <!--v-for="item in formSearch.queryParam[index+1].selectList3"-->
                    <!--:key="item.value"-->
                    <!--:label="item.label"-->
                    <!--:value="item.value"-->
                    <!--/>-->
                    <!--</el-select>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item v-if="formSearch.queryParam[index+1].inputType=='select'" :prop="['queryParam',index+1,'cxcs']">-->
                    <!--<el-cascader class="jsjb_form_bl_input" :props="{ emitPath: false }" clearable-->
                    <!--placeholder="请选择"-->
                    <!--v-model="formSearch.queryParam[index+1].cxcs"-->
                    <!--:options="formSearch.queryParam[index+1].selectList4"/>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item v-else-if="formSearch.queryParam[index+1].inputType=='date'" :prop="['queryParam',index+1,'cxcs']">-->
                    <!--<el-date-picker-->
                    <!--v-model="formSearch.queryParam[index+1].cxcs"-->
                    <!--class="jsjb_form_bl_input"-->
                    <!--format="YYYY-MM-DD HH:mm:ss"-->
                    <!--value-format="YYYY-MM-DD HH:mm:ss"-->
                    <!--type="datetime"-->
                    <!--placeholder="选择日期时间"-->
                    <!--/>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item v-else :prop="['queryParam',index+1,'cxcs']">-->
                    <!--<el-input v-model="formSearch.queryParam[index+1].cxcs" class="jsjb_form_bl_input"-->
                    <!--placeholder="请输入"/>-->
                    <!--</el-form-item>-->
                    <!--<el-button @click="reduceKeyword(index)">-->
                    <!--<el-icon>-->
                    <!--<minus/>-->
                    <!--</el-icon>-->
                    <!--</el-button>-->
                    <!--</div>-->
                    <!--<div class="jsjb_form_bottom_btn">-->
                    <!--<el-button class="" type="primary" @click="submitForm">-->
                    <!--<el-icon>-->
                    <!--<Search/>-->
                    <!--</el-icon>-->
                    <!--查询-->
                    <!--</el-button>-->
                    <!--</div>-->
                </div>
            </el-form>
        </div>
        <TableState ref="tableStateComponent" @workOrderImport="workOrderImport" @workorderCollect="workorderCollect"
                    @seletedTzlx="seletedTzlx"
                    :workOrderImportDisplay="workOrderImportDisplay" :tzlxNum="tzlxNum"></TableState>
        <TableComponent ref="tableChildFun" :tableArray="tableArray" @checkGdEva="checkGdEva"></TableComponent>
        <div class="jsjb_buttonPage">
            <div class="jsjb_button">
                <div class="jsjb_button_list" @click="extExcel">
                    <i class="icon-file-excel"></i>导出Excel
                </div>
                <div class="jsjb_button_list">
                    <i class="icon-file-wordine"></i>导出word
                </div>
                <div class="jsjb_button_list">
                    <i class="icon-liucheng"></i>导出Wrod(流程)
                </div>
                <div class="jsjb_button_list">
                    <i class="icon-alarmClock"></i>催办
                </div>
            </div>
            <el-pagination
                v-model:page-size="pageSize"
                :page-sizes="[50, 100,150, 200]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="rowsCount"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
        </div>
        <div class="modal" :style="{display:workOrderImportDisplay?'block':'none'}">
            <div class="modal_content workOrderImport">
                <div class="modal_title">
                    <p>工单导入</p>
                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ba633cb8=""
                         @click="passwordModalclose">
                        <path fill="currentColor"
                              d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm0 393.664L407.936 353.6a38.4 38.4 0 1 0-54.336 54.336L457.664 512 353.6 616.064a38.4 38.4 0 1 0 54.336 54.336L512 566.336 616.064 670.4a38.4 38.4 0 1 0 54.336-54.336L566.336 512 670.4 407.936a38.4 38.4 0 1 0-54.336-54.336L512 457.664z"></path>
                    </svg>
                </div>
                <div class="workOrderImport_main">
                    <div class="workOrderImport_main_list" @click="jumpHand">
                        <i class="icon-gddr_sdlr"></i>
                        <p>手动录入</p>
                    </div>
                    <div class="workOrderImport_main_list">
                        <i class="icon-gddr_pldr"></i>
                        <p>批量导入</p>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            width='450px'
            :title="title"
            v-model="visible"
            @close="closeModel"
        >
            <div v-if="!isNext" class="btn-export">
                <el-button type="primary" @click="handleExport(true)">带图片导出</el-button>
                <el-button type="primary" @click="handleExport(false)">不带图片导出</el-button>
            </div>
            <div v-else>
                <el-form ref="exportFormRef" :inline="true" :model="exportForm" :rules="rules">
                    <el-form-item label="导出页码" prop="pageNum">
                        <el-input v-model="exportForm.pageNum" :min="1" placeholder="请输入页码"></el-input>
                    </el-form-item>
                    <el-form-item label="导出条数" prop="pageSize">
                        <el-input v-model="exportForm.pageSize" placeholder="请输入页码"></el-input>
                    </el-form-item>
                    <div class="form-btn">
                        <el-button type="primary" @click="onSubmit(exportFormRef)">导出</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {reactive, onMounted, ref, watch, getCurrentInstance, nextTick} from 'vue'
    import {dateFormat} from "../../assets/js/base";
    import _ from "lodash";
    import TableState from '@/components/EventManage/Jsjb/TableState'
    import TableComponent from '@/components/EventManage/Jsjb/TableComponent'
    import {useStore} from 'vuex'
    import {useRouter} from 'vue-router'
    import qs from 'qs'
    import {ElLoading} from "element-plus";
    export default {
        name: "Jsjb",
        components: {
            TableState,
            TableComponent
        },
        setup() {

            let title = ref('导出Excel')
            let isPic = ref(false) // 是否带图片导出
            let visible = ref(false)
            let isNext = ref(false)
            const exportFormRef = ref()
            const exportForm = reactive({
                pageNum: '1',
                pageSize: ''
            })
            const rules = reactive({
                pageNum: [
                    { required: true, message: '请输入导出页码', trigger: 'blur' },
                    {
                        pattern: /^[1-9]\d*$/,
                        message: '请输入正整数',
                        trigger: 'blur'
                    }
                ],
                pageSize: [
                    { required: true, message: '请输入导出条数', trigger: 'blur' },
                    {
                        pattern: /^[1-9]\d*$/,
                        message: '请输入正整数',
                        trigger: 'blur'
                    }
                ],
            })
            watch(() => isNext.value, (val) => {
                if (val) {
                    title.value = isPic.value ? '导出Excel-带图片' : '导出Excel-不带图片'
                } else {
                    title.value = '导出Excel'
                }
            })
            const handleExport = (flag) => {
                isPic.value = flag
                isNext.value = true
            }
            const onSubmit = async (formEl) => {
                console.log(formEl)

                if (!formEl) return
                await formEl.validate((valid, fields) => {
                    console.log(valid)
                    if (valid) {
                        console.log('submit!')
                    } else {
                        console.log('error submit!', fields)
                    }
                })
            }
            const closeModel = () => {
                isPic.value = false
                isNext.value = false
                visible.value = false
            }

            const {proxy} = getCurrentInstance();
            const store = useStore();
            let router = useRouter();
            const ruleFormRef = ref();
            const tableChildFun = ref()
            //搜索条件 start
            let formSearch = reactive({
                tzlx: "",
                pageNum: "1",
                pageSize: "12",
                selectTime: "",
                gdJzsjStartTogdJzsjEnd: "",
                gdJzsj_start: "",
                gdJzsj_end: "",
                sfsc: "",
                query_yjcs: "",
                queryYjcs: "",
                query_jjcs: "",
                queryJjcs: "",
                query_glpptj: "",
                search: "",
                gdGdlx: "",
                gdSjlx: "",
                czFpdxdwid: "",
                formKey: "",
                gdGdbs: "",
                gdAfcs: "",
                gdGdlx_dic: [],
                gdSjlx_dic: [],
                czFpdxid_dic: [],
                formKey_dic: [],
                gdGdbs_dic: [],
                gdAfcs_dic: [],
                queryParam: [
                    {
                        field: "",   //查询的字段
                        gzcs: "",         //规则参数
                        cxcs: "", //查询参数
                        selectList3: [],//下拉框选项
                        selectList4: [],//下拉框选项
                        inputType: "",
                        "cxgz": "",
                        "cxtj": ""
                    },
                    {
                        field: "",   //查询的字段
                        gzcs: "",         //规则参数
                        cxcs: "", //查询参数
                        selectList3: [],//下拉框选项
                        selectList4: [],//下拉框选项
                        inputType: "",
                        "cxgz": "",
                        "cxtj": ""
                    }
                ]
            })
            //过滤匹配条件
            let filterMatchConditionSelect = ref();
            const filterMatchCondition = () => {
                proxy.$axios.post("/jgfast/wgsj/getCodeTable", {
                    "codeTable": "cxgz_glpptj"
                }).then((res) => {
                    filterMatchConditionSelect.value = res.data['cxgz_glpptj'];
                });
            }
            //高级查询条件
            let advancedQueryKeyword = ref()
            const advancedQuery = () => {
                proxy.$axios.post("/jgfast/wgsj/selGdtzcxzd").then((res) => {
                    advancedQueryKeyword.value = res.data;
                });
            }
            const selectKeyowordChange = (param) => {
                formSearch.queryParam[param].gzcs = "";
                formSearch.queryParam[param].cxcs = "";
                for (let i in advancedQueryKeyword.value) {
                    if (advancedQueryKeyword.value[i].field == formSearch.queryParam[param].field) {
                        formSearch.queryParam[param].inputType = advancedQueryKeyword.value[i].cxlx;
                        formSearch.queryParam[param].cxgz = advancedQueryKeyword.value[i].cxgz;
                        formSearch.queryParam[param].cxtj = advancedQueryKeyword.value[i].cxtj;
                    }
                }
                if (formSearch.queryParam[param].cxgz) {
                    proxy.$axios.post("/jgfast/wgsj/getCodeTable", {
                        "codeTable": formSearch.queryParam[param].cxgz
                    }).then((res) => {
                        formSearch.queryParam[param].selectList3 = res.data[formSearch.queryParam[param].cxgz];
                    });
                }
                if (formSearch.queryParam[param].cxtj) {
                    proxy.$axios.post("/jgfast/wgsj/getCodeTable", {
                        "codeTable": formSearch.queryParam[param].cxtj
                    }).then((res) => {
                        formSearch.queryParam[param].selectList4 = res.data[formSearch.queryParam[param].cxtj];
                    });
                }
            }
            const workorderCollect = (param) => {
                if (param) {
                    formSearch.sfsc = 1;
                } else {
                    formSearch.sfsc = null;
                }
            }
            //即将超时改变事件
            watch(() => formSearch.queryJjcs, (newVal) => {
                if (newVal) {
                    formSearch.query_jjcs = 1;
                    formSearch.query_yjcs = null;
                    formSearch.queryYjcs = false;
                } else {
                    formSearch.query_jjcs = null;
                }
            })
            // const queryJjcsChange = (param)=>{
            //     if(param){
            //         formSearch.query_jjcs = 1;
            //         formSearch.query_yjcs = null;
            //         formSearch.queryYjcs = false;
            //     }else{
            //         formSearch.query_jjcs = null;
            //     }
            // }
            //已经超时改变事件
            watch(() => formSearch.queryYjcs, (newVal) => {
                if (newVal) {
                    formSearch.query_jjcs = null;
                    formSearch.query_yjcs = 1;
                    formSearch.queryJjcs = false;
                } else {
                    formSearch.query_yjcs = null;
                }
            })
            watch([() => formSearch.gdGdlx_dic, () => formSearch.gdSjlx_dic, () => formSearch.czFpdxid_dic, () => formSearch.formKey_dic, () => formSearch.gdGdbs_dic, () => formSearch.gdAfcs_dic], (newVal) => {
                console.log(newVal)
                formSearch.gdGdlx = newVal[0][formSearch.gdGdlx_dic.length - 1]
                formSearch.gdSjlx = newVal[1][formSearch.gdSjlx_dic.length - 1]
                formSearch.czFpdxdwid = newVal[2][formSearch.czFpdxid_dic.length - 1]
                formSearch.formKey = newVal[3][formSearch.formKey_dic.length - 1]
                formSearch.gdGdbs = newVal[4][formSearch.gdGdbs_dic.length - 1]
                formSearch.gdAfcs = newVal[5][formSearch.gdAfcs_dic.length - 1]
            })
            // const queryYjcsChange =(param)=>{
            //     debugger
            //     if(param){
            //         formSearch.query_jjcs = null;
            //         formSearch.query_yjcs = 1;
            //         formSearch.queryJjcs = false;
            //     }else{
            //         formSearch.query_yjcs = null;
            //     }
            // }
            watch(() => formSearch.gdJzsjStartTogdJzsjEnd, (newVal, oldVal) => {
                if (newVal) {
                    [formSearch.gdJzsj_start, formSearch.gdJzsj_end] = newVal;

                } else {
                    [formSearch.gdJzsj_start, formSearch.gdJzsj_end] = ["", ""];
                    timeRangeDisabled.value = false;
                    formSearch.selectTime = "";
                }

            })
            //时间范围失去焦点
            const timeRangeChange = (param) => {
                if (formSearch.gdJzsjStartTogdJzsjEnd) {
                    timeRangeDisabled.value = true;
                    formSearch.selectTime = "";
                }
            }
            let timeRangeDisabled = ref(false);
            //今、3、7改变事件
            const selectTimeChange = (param) => {
                const start = new Date()
                start.setHours(0, 0, 0, 0)
                const end = new Date()
                if (param == 1) {
                    end.setTime(start.getTime() + 3600 * 1000 * 24 * 1)
                } else if (param == 2) {
                    end.setTime(start.getTime() + 3600 * 1000 * 24 * 3)
                } else if (param == 3) {
                    end.setTime(start.getTime() + 3600 * 1000 * 24 * 7)
                }
                formSearch.gdJzsjStartTogdJzsjEnd = [dateFormat(start), dateFormat(end)];
            }
            //重置
            const resetForm = (formEl) => {
                if (!formEl) return
                formEl.resetFields();
                tableChildFun.value.clearSortTable();
            }
            //高级查询
            const highSearchArrow = ref(true)
            const highSearch = () => {
                highSearchArrow.value = !highSearchArrow.value
                nextTick(() => {
                    store.state.wgsjSearchHight = searchHight.value.clientHeight;
                })

            }
            //搜索条件 end
            //工单导入 start
            const workOrderImportDisplay = ref(false)
            const workOrderImport = (param) => {
                workOrderImportDisplay.value = param;
            }
            const passwordModalclose = () => {
                workOrderImportDisplay.value = !workOrderImportDisplay.value;
            }
            const jumpHand = () => {
                workOrderImportDisplay.value = false;
                store.commit('addLeftTreeToHeaderTab', {
                    name: "Jsjb_handInput",
                    label: "手动录入",
                    linkTo: "/Jsjb_handInput",
                    query: null,
                });
            }
            //选择的台账类型字段
            const tzlxNum = ref({
                tzlx: "",
                tzlxNum: 0
            })
            const seletedTzlx = (param) => {
                if (param) {
                    formSearch.tzlx = param;
                }
                tzQuery();
            }
            //台账查询
            let tableArray = ref();
            let rowsCount = ref(0);//总条数子
            let pageSize = ref(12);//当前默认分页一页条数
            const tzQuery = (pageNum = 1) => {
                formSearch.pageNum = pageNum;
                proxy.$axios.post("/jgfast/wgsj/selGdxxlb", formSearch).then((res) => {
                    tableArray.value = res.data.vbs;
                    rowsCount.value = Number(res.data.rowsCount);
                    tzlxNum.value.tzlx = formSearch.tzlx;
                    tzlxNum.value.tzlxNum = Number(res.data.rowsCount);
                });
            }

            const converToUrl = requestParams => {
                let params = [];
                Object.entries(requestParams).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        value.forEach((item, index) => {
                            if (item instanceof Object) {
                                let param = key + '[' + index + ']' + '=' + JSON.stringify(item);
                                params.push(param);
                            } else {
                                let param = key + '=' + value;
                                params.push(param);
                            }
                        })
                    } else {
                        let param = key + '=' + value;
                        params.push(param);
                    }
                });
                return params.join('&');
            }

            //导出excel
            const checkGdData = ref([])
            const checkGdEva = (param) => {
                checkGdData.value = param;
            }
            const extExcel = () => {
                // visible.value = true
                //
                // if(true){
                //     return
                // }

                let loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                })

                let gdIds = [];
                for (let obj of checkGdData.value) {
                    gdIds.push(obj.gdId)
                }

                formSearch._u = "fast-wgsjlb.xml";
                formSearch.gdIds = gdIds.join(",");

                proxy.$axios.own.post('/jgfast/ureport/excel',qs.stringify(formSearch),{
                    responseType: 'blob',   //首先设置responseType字段格式为 blob
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
                }).then(res => {
                    let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"}); // 为blob设置文件类型，这里以.xlsx为例
                    let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = '网格事件列表.xlsx';
                    a.click();
                    // 释放这个临时的对象url
                    window.URL.revokeObjectURL(url);
                    loading.close();
                }).catch(() => {
                    loading.close();
                });
            }


            //工单导入 end
            //改变分页的一个显示条数
            const handleSizeChange = (param) => {
                formSearch.pageSize = param;
                tzQuery();
            }
            //分页改变当前页
            const handleCurrentChange = (param) => {
                tzQuery(param);
            }
            //增加减少关键词
            const addKeyword = () => {
                formSearch.queryParam.push(
                    {
                        field: "",   //查询的字段
                        gzcs: "",         //规则参数
                        cxcs: "",  //查询参数
                        selectList: [],//下拉框选项
                        inputType: "",
                        "cxgz": ""
                    }
                );
            }
            const reduceKeyword = (param) => {
                formSearch.queryParam.splice(param, 1);
            }
            //查询table
            //组件tableStateComponent的ref,操作子组件的方法
            const tableStateComponent = ref();
            const submitForm = () => {
                // tzQuery();
                tableStateComponent.value.queryUserType(true, formSearch)
            }
            //工单检索某块的高度
            const searchHight = ref();
            //input输入框回车
            const inputKeydown = (e) => {
                var evt = window.event || e;
                if (evt.keyCode == 13) {
                    tzQuery();
                }
            }
            // const inputLodash =_.debounce(()=>{
            //     tzQuery();
            // }, 2000, {
            //     leading: false,  // 延长开始后调用
            //     trailing: true  // 延长结束前调用
            // })
            let highSearchSelectedArray = ref([])
            let highSearchSelectedCbdw = ref([])
            onMounted(() => {
                // tzQuery();
                // advancedQuery();
                filterMatchCondition();
                store.state.wgsjSearchHight = searchHight.value.clientHeight;
                //高级查询承办单位
                proxy.$axios.post("/jgfast/wgsj/selCbdw").then((res) => {
                    highSearchSelectedCbdw.value = res.data
                });
                //高级查询select
                proxy.$axios.post("/jgfast/wgsj/getCodeTable", {
                    "codeTable": "cdg_wgsj_gdlx,cdg_wgsjlx,cdg_wgsj_gdzt,cdg_wgsj_gdbs,cdg_wgsj_afcs"
                }).then((res) => {
                    highSearchSelectedArray.value = res.data
                });
            });
            return {
                formSearch,
                highSearchArrow,
                highSearch,
                workOrderImport,
                workOrderImportDisplay,
                passwordModalclose,
                jumpHand,
                resetForm,
                ruleFormRef,
                tableArray,
                rowsCount,
                pageSize,
                handleSizeChange,
                handleCurrentChange,
                addKeyword,
                reduceKeyword,
                workorderCollect,
                timeRangeDisabled,
                submitForm,
                timeRangeChange,
                seletedTzlx,
                advancedQueryKeyword,
                selectKeyowordChange,
                filterMatchConditionSelect,
                selectTimeChange,
                extExcel,
                checkGdEva,
                searchHight,
                tableStateComponent,
                inputKeydown,
                tzlxNum,
                tableChildFun,
                highSearchSelectedArray,
                highSearchSelectedCbdw,
                title,
                visible,
                isPic,
                isNext,
                exportForm,
                rules,
                exportFormRef,
                handleExport,
                onSubmit,
                closeModel
            }
        }
    }
</script>

<style scoped>
.btn-export {
    width: 60%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.form-btn {
    text-align: center;
}
</style>
